import { KeyVal } from "../Layouts"
import { getProject } from "../../api/project"
import { useEffect, useState, useRef } from "react"
import { apis } from "../../constants"
import styles from './card.module.scss';
import { useNavigate } from "react-router-dom";
import { WarningFilled } from "@ant-design/icons";
import { Loading } from './Layouts'
import { PROJECT_IS_INTERSECTING } from "../../constants";
import ProjectMap from "./ProjectMap";

export const SkeletonCard = ({ width, height }: { width: string | number, height: string | number }) => {
    return (
        <div className={styles.card}
            style={{
                width: width,
                height: height,
            }}>
            <Loading />
        </div>
    )
}

export default function ProjectCard({ project, width, height, onProjectMounted }: {
    onProjectMounted: (ele: HTMLDivElement) => void,
    width: number, height: number, project: ProjectReportInfo,
}) {
    const [detail, setDetail] = useState<Project>();
    const [canFetchNow, setCanFetchNow] = useState(false);
    const [detailLoading, setDetailLoading] = useState(false);
    const imgContainerRef = useRef<HTMLImageElement>(null)
    const navigate = useNavigate();
    useEffect(() => {
        if (!canFetchNow || detailLoading || !!detail) return;
        setDetailLoading(true)
        getProject(project.project.projectId)
            .then(setDetail)
            .finally(() => {
                setDetailLoading(false)
            })
    }, [project, canFetchNow]);
    const hasImg = !!detail?.files?.[0]?.name;
    const imgUrl = hasImg ? apis.getImage.replace('{filename}', detail?.files[0].name) : '';
    const hasAlarm = project?.alarmCount > 0;
    const containerRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const cb = ({ detail }: any) => {
            if (containerRef.current === detail)
                setCanFetchNow(true)
        }
        window.addEventListener(PROJECT_IS_INTERSECTING, cb)
        return () => {
            window.removeEventListener(PROJECT_IS_INTERSECTING, cb)
        }
    }, []);
    useEffect(() => {
        onProjectMounted(containerRef.current!)
    }, [])
    return (
        <div
            ref={containerRef}
            className={styles.card}
            style={{
                width: width,
                height: height,
            }}>
            <a onClick={e => {
                e.preventDefault();
                navigate('./' + project.project.projectId)
            }} style={{ color: 'inherit', cursor: 'pointer', marginBottom: 4, display: 'flex', alignItems: 'center' }}>
                <span className={styles.title}>
                    {project.project.name}
                </span>
                {hasAlarm && <WarningFilled style={{ color: 'yellow', marginLeft: 10 }} />}
            </a>
            <div style={{ display: 'flex', fontSize: '0.9em', justifyContent: 'space-between' }}>
                <KeyVal name="设备总数" value={project.deviceCount} />
                <KeyVal name="在线设备" value={project.onlineCount} />
                <KeyVal name="离线设备" value={project.offlineCount} />
                <KeyVal name="告警总数" value={<span style={{
                    color: hasAlarm ? 'red' : 'inherit'
                }}>
                    {project.alarmCount}
                </span>} />
            </div>
            <div className={styles.img} onClick={(e) => {
                e.stopPropagation()
            }} style={{
                height: 'calc(100% - 60px)',
                overflow: 'hidden',
                textAlign: 'center',
            }} ref={imgContainerRef}>
                {(!!detail && <ProjectMap isStatic project={detail} imgUrl={imgUrl} />)}
            </div>
        </div>
    )
}